const menu = [
  {
    path: '/index',
    name: '主页',
    icon: 'icon-dynamic_fill',
    level: 1,
    sort: 1,
    children: [],
    fixed: false
  },
  // {
  //   path: '/',
  //   name: '系统管理',
  //   icon: 'ios-add-circle',
  //   level: 0,
  //   fixed: false,
  //   children: [
  //     {
  //       path: '/userInfo',
  //       name: '用户信息',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/menuconfig',
  //       name: '菜单设置',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/rootconfig',
  //       name: '角色设置',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/sysuserconfig',
  //       name: '用户管理',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/changepassword',
  //       name: '密码修改',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     }
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '厂商管理',
  //   icon: 'ios-add-circle',
  //   level: 0,
  //   fixed: false,
  //   children: [
  //
  //     {
  //       path: '/vendortype',
  //       name: '产品类型',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/vendorinfo',
  //       name: '厂商管理',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/autodevicenum',
  //       name: '自动编号生成',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '心电监护',
  //   icon: 'ios-add-circle',
  //   level: 0,
  //   fixed: false,
  //   children: [
  //     {
  //       path: '/ecgmonitor',
  //       name: '心电墙',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //   ]
  // },
  // {
  //   path: '/',
  //   name: '用户数据',
  //   icon: 'ios-add-circle',
  //   level: 0,
  //   fixed: false,
  //   children: [
  //     {
  //       path: '/ecgmonitorData',
  //       name: '用户使用数据',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //     {
  //       path: '/customPageList',
  //       name: '客户列表',
  //       icon: 'ios-add-circle',
  //       children: [],
  //       fixed: false,
  //       level: 1
  //     },
  //   ]
  // }

]

export default menu



// WEBPACK FOOTER //
// ./src/router/menu.js